module.exports = __webpack_public_path__ + "img/I.COM.70110194.svg";